// src/Components/Forms/Financement/Salam/Reception/ReceptionSalam.tsx
import { useState } from 'react';
import { Tabs, Space, Button, Form, Spin } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json';
import SweetAlert from 'sweetalert2';
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Typography } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';

const Reception = () => {
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  const authHeader = useAuthHeader();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [modifActve, setModifActve] = useState(true);
  const [annulActive, setAnnulActive] = useState(true);
  const [enregActve, setEnregActve] = useState(true);
  const [historiqueLivraisons, setHistoriqueLivraisons] = useState<any[]>([]);
  const [loadingLivraisons, setLoadingLivraisons] = useState(false);

  const loadHistoriqueLivraisons = (numeroDemande: string) => {
    setLoadingLivraisons(true);
    const searchParams: ParamsPicklist = {
      CodeAgence: '',
      Table: 'LivraisonSalam',
      Colonne1: 'NumeroDemande',
      Colonne2: '',
      Init: numeroDemande,
      Colagence: '',
      Choix: 35,
    };
    const config = {
      method: 'get',
      url: Data.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader(),
        CypherSearch: Crypter.encrypt(JSON.stringify(searchParams)),
      },
    };
    axios
      .request(config)
      .then((response) => {
        setLoadingLivraisons(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          console.log('Historique livraisons response:', res);
          if (res.StatutCode === 200) {
            const livraisons = res.Result.Table || [];
            setHistoriqueLivraisons(livraisons);
          } else {
            setHistoriqueLivraisons([]);
          }
        } else {
          setHistoriqueLivraisons([]);
        }
      })
      .catch((error) => {
        setLoadingLivraisons(false);
        console.error('Erreur chargement historique livraisons :', error);
        setHistoriqueLivraisons([]);
      });
  };

  const loadFinancement = () => {
    setPageLoad(false);
    setLoading(true);
    setData([]);
    const searchParams: ParamsPicklist = {
      CodeAgence: user.codage,
      Table: 'view_AnySuiviLivraisonSalam',
      Colonne1: 'EtapeActuelle',
      Colonne2: '',
      Init: 'RECEPTION',
      Colagence: 'CODAGE',
      Choix: 34,
    };
    const config = {
      method: 'get',
      url: Data.ApiUrl.AnySearch,
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader(),
        CypherSearch: Crypter.encrypt(JSON.stringify(searchParams)),
      },
    };
    axios
      .request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;
          if (res.StatutCode === 200) {
            const datas = res.Result.Table;
            if (datas.length === 0) {
              SweetAlert.fire({
                title: res.Message || 'Aucune demande Salam en attente de réception',
                text: res.Result || 'Toutes les demandes ont été réceptionnées ou ne sont pas encore payées.',
                icon: 'info'
              });
            } else {
              const newData = datas.map((item: any, index: number) => ({
                key: index,
                NumeroDemande: item.NumeroDemande,
                NumeroFinancement: item.NumeroFinancement,
                CodeSalam: item.CodeSalam,
                NOMCLI: item.Nomcli,
                Quantite: item.QuantiteContractuelle,
                Unite: item.Unite,
                DateLivraison: item.DateLivraisonPrevue ? item.DateLivraisonPrevue.split('T')[0] : '',
                ResteALivrer: item.ResteALivrer,
              }));
              setData(newData);
            }
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        SweetAlert.fire({
          title: 'Erreur',
          text: error.toString(),
          icon: 'error'
        });
      });
  };

  if (pageLoad) loadFinancement();

  const columns: ColumnsType<any> = [
    { title: 'N° Demande', dataIndex: 'NumeroDemande' },
    { title: 'N° Financement', dataIndex: 'NumeroFinancement' },
    { title: 'Type Salam', dataIndex: 'CodeSalam' },
    { title: 'Client', dataIndex: 'NOMCLI' },
    { title: 'Qté commandée', dataIndex: 'Quantite', render: (v) => formatNumber(v) },
    { title: 'Unité', dataIndex: 'Unite' },
    { title: 'Reste à livrer', dataIndex: 'ResteALivrer', render: (v) => formatNumber(v) },
    { title: 'Livraison prévue', dataIndex: 'DateLivraison' },
  ];

  const handleDemandeSalam = (numero: string, extraFields: any) => {
    setLoading(true);
    const config = {
      method: 'POST',
      url: Data.ApiUrl.ReadFinancementSalam,
      headers: {
        Authorization: authHeader(),
        'Content-Type': 'application/json',
        CypherNumeroDemandeSalam: Crypter.encrypt(numero),
        CypherAction: Crypter.encrypt('READ_DEMANDE'),
      },
    };
    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
        if (res.StatutCode === 200 && res.Result.Table1 && res.Result.Table1.length > 0) {
          const data = res.Result.Table1[0];
          // ✅ Alignement sur le DTO
          const formValues = {
            NumeroDemande: data.NumeroDemande,
            NumeroFinancement: extraFields.NumeroFinancement,
            CodeSalam: data.CodeSalam,
            NOMCLI: data.NOMCLI || data.Nomcli,
            Quantite: data.Quantite,
            Unite: data.Unite,
            LieuLivraison: data.LieuLivraison || '',
            DateLivraison: data.DateLivraison ? data.DateLivraison.split('T')[0] : '',
            ResteALivrer: extraFields.ResteALivrer,
            DateReceptionReelle: new Date().toISOString().split('T')[0],
            QuantiteRecue: extraFields.ResteALivrer || 0,
            ReferenceBordereau: '',
            CommentaireReception: '',
          };
          form.setFieldsValue(formValues);
          loadHistoriqueLivraisons(numero);
          setModifActve(false);
          setEnregActve(false);
          setAnnulActive(false);
        } else {
          SweetAlert.fire({
            title: res.Message || "Demande non trouvée",
            text: res.Result || "Vérifiez le numéro de la demande.",
            icon: "warning"
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error('Erreur lors du chargement :', error);
        SweetAlert.fire({
          title: 'Erreur',
          text: error.toString(),
          icon: 'error'
        });
      });
  };

  const onSelectChange = (newSelectedRowKeys: any) => {
    const index = Array.isArray(newSelectedRowKeys) ? newSelectedRowKeys[0] : newSelectedRowKeys;
    if (index !== undefined && data[index]) {
      const row = data[index];
      form.setFieldsValue({
        NumeroDemande: row.NumeroDemande,
        NumeroFinancement: row.NumeroFinancement,
        CodeSalam: row.CodeSalam,
        NOMCLI: row.NOMCLI,
        Quantite: row.Quantite,
        Unite: row.Unite,
        DateLivraison: row.DateLivraison,
        ResteALivrer: row.ResteALivrer,
      });
      handleDemandeSalam(row.NumeroDemande, {
        NumeroFinancement: row.NumeroFinancement,
        ResteALivrer: row.ResteALivrer,
      });
    }
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = { selectedRowKeys, onChange: onSelectChange };

  const onFinish = () => {
    const values = form.getFieldsValue(true);
    const payload = {
      NumeroDemande: values.NumeroDemande,
      QuantiteReceived: parseFloat(values.QuantiteRecue) || 0,
      LieuLivraison: values.LieuLivraison || '',
      ReferenceBordereau: values.ReferenceBordereau || '',
      Observations: values.CommentaireReception || '',
      CodeUti: user.coduti,
      Documents: values.DocumentsReception || [],
    };

    SweetAlert.fire({
      title: `Voulez-vous enregistrer la réception pour la demande Salam de type ${values.CodeSalam}\n du client : ${values.NOMCLI}\n Quantité reçue : ${formatNumber(values.QuantiteRecue)} ${values.Unite || ''} ?`,
      showCancelButton: true,
      confirmButtonText: "Oui, confirmer",
      cancelButtonText: "Annuler",
      icon: "question",
      confirmButtonColor: "orange",
      cancelButtonColor: "darkred"
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        const config = {
          method: 'POST',
          url: Data.ApiUrl.RealiseLivraison,
          headers: {
            Authorization: authHeader(),
            'Content-Type': 'application/json',
          },
          data: Crypter.encrypt(JSON.stringify(payload)),
        };
        axios
          .request(config)
          .then((response) => {
            setLoading(false);
            const res = JSON.parse(Crypter.decrypt(response.data)).Value;
            if (res.StatutCode === 200) {
              SweetAlert.fire({
                title: res.Message || "Réception enregistrée avec succès",
                text: res.Result,
                icon: 'success'
              });
              form.resetFields();
              setHistoriqueLivraisons([]);
              setSelectedRowKeys([]);
              loadFinancement();
              setModifActve(true);
              setEnregActve(true);
              setAnnulActive(true);
            } else {
              SweetAlert.fire({
                title: res.Message || "Erreur",
                text: res.Result || "Une erreur s'est produite.",
                icon: 'warning'
              });
            }
          })
          .catch((error) => {
            setLoading(false);
            SweetAlert.fire({
              title: 'Erreur',
              text: error.toString(),
              icon: 'error'
            });
          });
      }
    });
  };

  const handleAnnul = () => {
    form.resetFields();
    setHistoriqueLivraisons([]);
    setSelectedRowKeys([]);
    setModifActve(true);
    setEnregActve(true);
    setAnnulActive(true);
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span><UserOutlined /> Détails réception</span>,
      children: <Tab1 form={form} />,
    },
    {
      key: '2',
      label: <span><UserOutlined /> Documents</span>,
      children: <Tab2 form={form} />,
    },
    {
      key: '3',
      label: <span><UserOutlined /> Historique livraisons</span>,
      children: <Tab3 data={historiqueLivraisons} loading={loadingLivraisons} />,
    },
  ];

  return (
    <div className="tab">
      <Typography align="center" className="formTitle"><b>RÉCEPTION SALAM</b></Typography>
      <Spin spinning={loading} size="large" style={{ color: 'green' }}>
        <Form form={form} onFinish={onFinish} autoComplete="off" labelAlign="left">
          <div className="bG">
            <legend><Typography color="darkgreen">Actions</Typography></legend>
            <Form.Item shouldUpdate className="bouttong">
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button
                  size="large"
                  className="bt_add"
                  disabled={enregActve}
                  type="ghost"
                  htmlType="submit"
                  block
                  style={{ backgroundColor: 'orange', color: 'white' }}
                >
                  Enregistrer réception
                </Button>
                <Button
                  size="large"
                  disabled={annulActive}
                  onClick={handleAnnul}
                  className="bt_add"
                  type="ghost"
                  htmlType="button"
                  block
                >
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className="clientP">
            <Tabs size="small" type="card" defaultActiveKey="1" items={items} />
            <div className="border-left tabElementAuto">
              <Spin spinning={loading}>
                <Table
                  size="small"
                  rowSelection={{ ...rowSelection, type: 'radio' }}
                  columns={columns}
                  dataSource={data}
                  scroll={{ y: 120 }}
                  pagination={false}
                />
              </Spin>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default Reception;